import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 1000 * 60 * 5, // 5 min
      // cacheTime: 1000 * 60 * 30, // 10 min
      staleTime: 1000 * 60, // 10 seconds
      cacheTime: 1000 * 60, // 10 seconds
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
